import { __extends } from "tslib";
import { AssetBase } from '@awayjs/core';
/**
 * Provides an abstract base class for nodes in an animation blend tree.
 */
var AnimationNodeBase = /** @class */ (function (_super) {
    __extends(AnimationNodeBase, _super);
    /**
     * Creates a new <code>AnimationNodeBase</code> object.
     */
    function AnimationNodeBase() {
        return _super.call(this) || this;
    }
    Object.defineProperty(AnimationNodeBase.prototype, "stateClass", {
        get: function () {
            return this._pStateClass;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @inheritDoc
     */
    AnimationNodeBase.prototype.dispose = function () {
    };
    Object.defineProperty(AnimationNodeBase.prototype, "assetType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return AnimationNodeBase.assetType;
        },
        enumerable: true,
        configurable: true
    });
    AnimationNodeBase.assetType = '[asset AnimationNodeBase]';
    return AnimationNodeBase;
}(AssetBase));
export { AnimationNodeBase };
